import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_info_circle_blue.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_info_circle_gray.svg'


const _hoisted_1 = { class: "w-full bg-white border rounded-lg border-gray-lp-1400 mb-4" }
const _hoisted_2 = { class: "flex flex-row whitespace-nowrap" }
const _hoisted_3 = { class: "pl-3 pr-2 items-center bg-gray-lp-700 text-black-lp-300 text-12px flex flex-row max-w-max whitespace-nowrap rounded-tl-lg py-1" }
const _hoisted_4 = {
  key: 0,
  class: "pl-2 pr-2 items-center text-black-lp-300 text-12px flex flex-row max-w-max whitespace-nowrap rounded-br-lg py-1 font-semibold border-l border-r border-b border-gray-lp-1400"
}
const _hoisted_5 = {
  key: 1,
  class: "ml-auto justify-self-end px-2 items-center bg-gray-lp-700 text-black-lp-300 text-12px flex flex-row max-w-max whitespace-nowrap rounded-tr-lg py-1 gap-0.5"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "w-full p-4" }
const _hoisted_10 = { class: "w-full flex gap-10 items-center" }
const _hoisted_11 = { class: "w-1.5/5 flex justify-between flex-grow items-center" }
const _hoisted_12 = { class: "text-24px text-black-lp-100 font-bold" }
const _hoisted_13 = { class: "capitalize text-12px text-black-lp-100 font-semibold" }
const _hoisted_14 = {
  key: 0,
  width: "70",
  height: "44",
  viewBox: "0 0 60 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(30 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(0 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_dd_14900_17574)" }, [
  /*#__PURE__*/_createVNode("mask", {
    id: "path-1-inside-1_14900_17574",
    fill: "white"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z" })
  ]),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z",
    fill: "white",
    "shape-rendering": "crispEdges"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16M44 16M44 16M16 16M30 2M44 16M30 30M16 16M30 30V29C22.8203 29 17 23.1797 17 16H16H15C15 24.2843 21.7157 31 30 31V30ZM44 16H43C43 23.1797 37.1797 29 30 29V30V31C38.2843 31 45 24.2843 45 16H44ZM30 2V3C37.1797 3 43 8.8203 43 16H44H45C45 7.71573 38.2843 1 30 1V2ZM30 2V1C21.7157 1 15 7.71573 15 16H16H17C17 8.8203 22.8203 3 30 3V2Z",
    fill: "#F3F4F6",
    mask: "url(#path-1-inside-1_14900_17574)"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M27.1851 20.763C26.966 20.4573 26.9077 20.0647 27.0285 19.7085L27.6722 17.8114L27.3219 17.8114L26.855 18.4433C26.635 18.741 26.2868 18.9167 25.9167 18.9167L25.3333 18.9167C24.9309 18.9167 24.5568 18.7092 24.3437 18.3678C24.1305 18.0264 24.1084 17.5992 24.2852 17.2377L24.8902 16L24.2852 14.7623C24.1084 14.4007 24.1305 13.9736 24.3437 13.6322C24.5568 13.2908 24.9309 13.0833 25.3333 13.0833L25.9167 13.0833C26.2868 13.0833 26.635 13.259 26.855 13.5567L27.3219 14.1886L27.6722 14.1886L27.0285 12.2915C26.9077 11.9353 26.966 11.5427 27.1851 11.237C27.4042 10.9313 27.7572 10.75 28.1333 10.75L29.0667 10.75C29.4534 10.75 29.8149 10.9416 30.0321 11.2616L32.0182 14.1886L33.9667 14.1886C34.9061 14.1886 35.8333 14.9104 35.8333 16C35.8333 17.0896 34.9061 17.8114 33.9667 17.8114L32.0182 17.8114L30.0321 20.7384C29.8149 21.0584 29.4534 21.25 29.0667 21.25L28.1333 21.25C27.7572 21.25 27.4042 21.0687 27.1851 20.763ZM28.4861 16.6447C28.8856 16.6447 29.1668 17.0372 29.0385 17.4155L28.1333 20.0833L29.0667 20.0833L31.2264 16.9005C31.335 16.7405 31.5158 16.6447 31.7091 16.6447L33.9667 16.6447C34.354 16.6447 34.6667 16.3568 34.6667 16C34.6667 15.6432 34.354 15.3553 33.9667 15.3553L31.7091 15.3553C31.5158 15.3553 31.335 15.2595 31.2264 15.0995L29.0667 11.9167L28.1333 11.9167L29.0385 14.5845C29.1668 14.9628 28.8856 15.3553 28.4861 15.3553L27.0276 15.3553C26.8425 15.3553 26.6684 15.2674 26.5585 15.1186L25.9167 14.25L25.3333 14.25L26.1887 16L25.3333 17.75L25.9167 17.75L26.5585 16.8814C26.6684 16.7326 26.8425 16.6447 27.0276 16.6447L28.4861 16.6447Z",
    fill: "#333333"
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_dd_14900_17574",
    x: "13",
    y: "0",
    width: "34",
    height: "34",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feMorphology", {
      radius: "1",
      operator: "erode",
      in: "SourceAlpha",
      result: "effect1_dropShadow_14900_17574"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_14900_17574"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1.5" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "effect1_dropShadow_14900_17574",
      result: "effect2_dropShadow_14900_17574"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect2_dropShadow_14900_17574",
      result: "shape"
    })
  ])
], -1)
const _hoisted_19 = {
  key: 1,
  width: "60",
  height: "34",
  viewBox: "0 0 60 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(30 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(0 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_dd_15036_36831)" }, [
  /*#__PURE__*/_createVNode("mask", {
    id: "path-1-inside-1_15036_36831",
    fill: "white"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z" })
  ]),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z",
    fill: "white",
    "shape-rendering": "crispEdges"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16M44 16M44 16M16 16M30 2M44 16M30 30M16 16M30 30V29C22.8203 29 17 23.1797 17 16H16H15C15 24.2843 21.7157 31 30 31V30ZM44 16H43C43 23.1797 37.1797 29 30 29V30V31C38.2843 31 45 24.2843 45 16H44ZM30 2V3C37.1797 3 43 8.8203 43 16H44H45C45 7.71573 38.2843 1 30 1V2ZM30 2V1C21.7157 1 15 7.71573 15 16H16H17C17 8.8203 22.8203 3 30 3V2Z",
    fill: "#F3F4F6",
    mask: "url(#path-1-inside-1_15036_36831)"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M31.1667 12.5C30.8445 12.5 30.5833 12.7611 30.5833 13.0833V19.5H29.3166C29.2304 19.2562 29.0904 19.0322 28.9041 18.8459C28.5759 18.5177 28.1308 18.3333 27.6667 18.3333C27.2025 18.3333 26.7574 18.5177 26.4292 18.8459C26.2429 19.0322 26.1029 19.2562 26.0167 19.5H25.9167V18.3333C25.9167 18.0111 25.6555 17.75 25.3333 17.75C25.0112 17.75 24.75 18.0111 24.75 18.3333V19.5C24.75 19.8094 24.8729 20.1061 25.0917 20.3249C25.3105 20.5437 25.6072 20.6666 25.9167 20.6666H26.0167C26.1029 20.9104 26.2429 21.1344 26.4292 21.3207C26.7574 21.6489 27.2025 21.8333 27.6667 21.8333C28.1308 21.8333 28.5759 21.6489 28.9041 21.3207C29.0904 21.1344 29.2304 20.9104 29.3166 20.6666H30.5833C30.7899 20.6666 30.9908 20.6118 31.1667 20.5103C31.3425 20.6118 31.5434 20.6666 31.75 20.6666H31.8501C31.9363 20.9104 32.0762 21.1344 32.2626 21.3207C32.5907 21.6489 33.0359 21.8333 33.5 21.8333C33.9641 21.8333 34.4092 21.6489 34.7374 21.3207C34.9238 21.1344 35.0637 20.9104 35.1499 20.6666H35.25C35.5594 20.6666 35.8562 20.5437 36.075 20.3249C36.2937 20.1061 36.4167 19.8094 36.4167 19.5V16.8247C36.4166 16.5153 36.2936 16.2186 36.0748 15.9998L34.0834 14.0084C33.8647 13.7896 33.5679 13.6667 33.2585 13.6666H31.75C31.75 13.5352 31.75 13.3048 31.75 13.0833C31.75 12.7611 31.4888 12.5 31.1667 12.5ZM31.8501 19.5H31.75V14.8333L33.2584 14.8334L35.25 16.8249V19.5H35.1499C35.0637 19.2562 34.9238 19.0322 34.7374 18.8459C34.4092 18.5177 33.9641 18.3333 33.5 18.3333C33.0359 18.3333 32.5907 18.5177 32.2626 18.8459C32.0762 19.0322 31.9363 19.2562 31.8501 19.5ZM27.2542 19.6708C27.3636 19.5614 27.512 19.5 27.6667 19.5C27.8214 19.5 27.9697 19.5614 28.0791 19.6708C28.1885 19.7802 28.25 19.9286 28.25 20.0833C28.25 20.238 28.1885 20.3864 28.0791 20.4958C27.9697 20.6052 27.8214 20.6666 27.6667 20.6666C27.512 20.6666 27.3636 20.6052 27.2542 20.4958C27.1448 20.3864 27.0833 20.238 27.0833 20.0833C27.0833 19.9286 27.1448 19.7802 27.2542 19.6708ZM33.0875 19.6708C33.1969 19.5614 33.3453 19.5 33.5 19.5C33.6547 19.5 33.8031 19.5614 33.9125 19.6708C34.0219 19.7802 34.0833 19.9286 34.0833 20.0833C34.0833 20.238 34.0219 20.3864 33.9125 20.4958C33.8031 20.6052 33.6547 20.6666 33.5 20.6666C33.3453 20.6666 33.1969 20.6052 33.0875 20.4958C32.9781 20.3864 32.9167 20.238 32.9167 20.0833C32.9167 19.9286 32.9781 19.7802 33.0875 19.6708Z",
    fill: "#333333"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M25.3333 10.1666C25.6555 10.1666 25.9167 10.4278 25.9167 10.75V11.3333H27.6667V10.75C27.6667 10.4278 27.9278 10.1666 28.25 10.1666C28.5722 10.1666 28.8333 10.4278 28.8333 10.75V11.3333C28.8333 11.3663 28.8306 11.3986 28.8253 11.4301C29.5092 11.668 30 12.3183 30 13.0833V15.4166C30 16.3831 29.2165 17.1666 28.25 17.1666H25.3333C24.3668 17.1666 23.5833 16.3831 23.5833 15.4166V13.0833C23.5833 12.3183 24.0741 11.668 24.758 11.4301C24.7527 11.3986 24.75 11.3663 24.75 11.3333V10.75C24.75 10.4278 25.0112 10.1666 25.3333 10.1666ZM25.3333 12.5C25.0112 12.5 24.75 12.7611 24.75 13.0833V15.4166C24.75 15.7388 25.0112 16 25.3333 16H28.25C28.5722 16 28.8333 15.7388 28.8333 15.4166V13.0833C28.8333 12.7611 28.5722 12.5 28.25 12.5H25.3333ZM26.5 14.25C26.5 13.9278 26.7612 13.6666 27.0833 13.6666H27.6667C27.9888 13.6666 28.25 13.9278 28.25 14.25V14.8333C28.25 15.1555 27.9888 15.4166 27.6667 15.4166H27.0833C26.7612 15.4166 26.5 15.1555 26.5 14.8333V14.25Z",
    fill: "#333333"
  })
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_dd_15036_36831",
    x: "13",
    y: "0",
    width: "34",
    height: "34",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feMorphology", {
      radius: "1",
      operator: "erode",
      in: "SourceAlpha",
      result: "effect1_dropShadow_15036_36831"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_15036_36831"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1.5" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "effect1_dropShadow_15036_36831",
      result: "effect2_dropShadow_15036_36831"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect2_dropShadow_15036_36831",
      result: "shape"
    })
  ])
], -1)
const _hoisted_24 = {
  key: 2,
  width: "60",
  height: "34",
  viewBox: "0 0 60 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(30 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("rect", {
  width: "30",
  height: "1",
  transform: "translate(0 16)",
  fill: "#333333"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("g", { filter: "url(#filter0_dd_15036_40555)" }, [
  /*#__PURE__*/_createVNode("mask", {
    id: "path-1-inside-1_15036_40555",
    fill: "white"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z" })
  ]),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16C16 8.26801 22.268 2 30 2C37.732 2 44 8.26801 44 16C44 23.732 37.732 30 30 30C22.268 30 16 23.732 16 16Z",
    fill: "white",
    "shape-rendering": "crispEdges"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M16 16M44 16M44 16M16 16M30 2M44 16M30 30M16 16M30 30V29C22.8203 29 17 23.1797 17 16H16H15C15 24.2843 21.7157 31 30 31V30ZM44 16H43C43 23.1797 37.1797 29 30 29V30V31C38.2843 31 45 24.2843 45 16H44ZM30 2V3C37.1797 3 43 8.8203 43 16H44H45C45 7.71573 38.2843 1 30 1V2ZM30 2V1C21.7157 1 15 7.71573 15 16H16H17C17 8.8203 22.8203 3 30 3V2Z",
    fill: "#F3F4F6",
    mask: "url(#path-1-inside-1_15036_40555)"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M28.25 11.3333C28.25 11.0112 28.5112 10.75 28.8333 10.75H31.1667C31.4888 10.75 31.75 11.0112 31.75 11.3333V12.5H32.9167C33.2388 12.5 33.5 12.7612 33.5 13.0833V15.6904L34.8083 16.0174C35.1133 16.0937 35.3031 16.3981 35.2372 16.7056L34.3622 20.7889C34.3045 21.0579 34.0668 21.25 33.7918 21.25H26.2084C25.9334 21.25 25.6957 21.0579 25.6381 20.7889L24.7631 16.7056C24.6972 16.3981 24.8869 16.0937 25.192 16.0174L26.5 15.6904V13.0833C26.5 12.7612 26.7612 12.5 27.0833 12.5H28.25V11.3333ZM30.5833 11.9167V12.5H29.4167V11.9167H30.5833ZM27.6667 15.2784V13.6667H28.8333H31.1667H32.3333V15.2784L30.1222 14.8046C30.0417 14.7874 29.9583 14.7874 29.8778 14.8046L27.6667 15.2784ZM26.68 20.0833L26.022 17.0125L30.0001 16.018L33.9782 17.0125L33.3202 20.0833H26.68ZM33.0312 17.4697L30.0001 16.8635L26.969 17.4697C26.6531 17.5329 26.4483 17.8402 26.5114 18.1561C26.5746 18.472 26.8819 18.6769 27.1978 18.6137L30.0001 18.0532L32.8024 18.6137C33.1183 18.6769 33.4256 18.472 33.4888 18.1561C33.552 17.8402 33.3471 17.5329 33.0312 17.4697Z",
    fill: "#333333"
  })
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("defs", null, [
  /*#__PURE__*/_createVNode("filter", {
    id: "filter0_dd_15036_40555",
    x: "13",
    y: "0",
    width: "34",
    height: "34",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feMorphology", {
      radius: "1",
      operator: "erode",
      in: "SourceAlpha",
      result: "effect1_dropShadow_15036_40555"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_15036_40555"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      in: "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }),
    /*#__PURE__*/_createVNode("feOffset", { dy: "1" }),
    /*#__PURE__*/_createVNode("feGaussianBlur", { stdDeviation: "1.5" }),
    /*#__PURE__*/_createVNode("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }),
    /*#__PURE__*/_createVNode("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in2: "effect1_dropShadow_15036_40555",
      result: "effect2_dropShadow_15036_40555"
    }),
    /*#__PURE__*/_createVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "effect2_dropShadow_15036_40555",
      result: "shape"
    })
  ])
], -1)
const _hoisted_29 = { class: "flex flex-col items-end" }
const _hoisted_30 = { class: "text-24px text-black-lp-100 font-bold" }
const _hoisted_31 = { class: "capitalize text-12px text-black-lp-100 font-semibold" }
const _hoisted_32 = { class: "flex gap-3 items-center" }
const _hoisted_33 = {
  class: "flex gap-1 justify-end",
  style: {"min-width":"135px"}
}
const _hoisted_34 = {
  key: 0,
  class: "ml-1 bg-red-lp-1300 rounded text-center text-red-lp-2000 font-semibold text-xs p-1"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" DG ")
const _hoisted_36 = {
  key: 1,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-semibold text-xs p-1"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" K ")
const _hoisted_38 = {
  key: 2,
  class: "bg-black-lp-100 rounded text-center text-white font-semibold text-xs p-1"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" BOSSPACK ")
const _hoisted_40 = { style: {"min-width":"250px"} }
const _hoisted_41 = {
  key: 0,
  class: "flex items-center gap-1 bg-blue-lp-600 p-1 rounded-md",
  style: {"width":"max-content"}
}
const _hoisted_42 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.00001 3.33325C7.07703 3.33325 6.17477 3.60695 5.40735 4.11973C4.63992 4.63251 4.04178 5.36134 3.68857 6.21406C3.33536 7.06678 3.24294 8.0051 3.42301 8.91034C3.60307 9.81559 4.04753 10.6471 4.70017 11.2998C5.35282 11.9524 6.18434 12.3969 7.08959 12.5769C7.99483 12.757 8.93314 12.6646 9.78586 12.3114C10.6386 11.9581 11.3674 11.36 11.8802 10.5926C12.393 9.82515 12.6667 8.9229 12.6667 7.99992C12.6667 6.76224 12.175 5.57526 11.2998 4.70009C10.4247 3.82492 9.23768 3.33325 8.00001 3.33325ZM7.33334 1.99992V2.03707C7.16481 2.05591 6.9967 2.08194 6.82946 2.11521C5.66558 2.34672 4.59648 2.91816 3.75737 3.75728C2.91825 4.59639 2.34681 5.66549 2.1153 6.82938C1.88378 7.99326 2.0026 9.19966 2.45673 10.296C2.91086 11.3924 3.67989 12.3294 4.66659 12.9887C5.65328 13.648 6.81332 13.9999 8.00001 13.9999C9.5913 13.9999 11.1174 13.3678 12.2426 12.2426C13.3679 11.1173 14 9.59122 14 7.99992C14 6.81323 13.6481 5.65319 12.9888 4.6665C12.3295 3.6798 11.3925 2.91077 10.2961 2.45664C9.77252 2.23977 9.22384 2.09936 8.66667 2.03707V1.99992C8.66667 1.82311 8.59644 1.65354 8.47141 1.52851C8.34639 1.40349 8.17682 1.33325 8.00001 1.33325C7.8232 1.33325 7.65363 1.40349 7.5286 1.52851C7.40358 1.65354 7.33334 1.82311 7.33334 1.99992ZM10.6667 8.99992H8.00001C7.8232 8.99992 7.65363 8.92968 7.5286 8.80466C7.40358 8.67963 7.33334 8.51006 7.33334 8.33325V5.33325C7.33334 5.15644 7.40358 4.98687 7.5286 4.86185C7.65363 4.73682 7.8232 4.66659 8.00001 4.66659C8.17682 4.66659 8.34639 4.73682 8.47141 4.86185C8.59644 4.98687 8.66667 5.15644 8.66667 5.33325V7.66659H10.6667C10.8435 7.66659 11.0131 7.73682 11.1381 7.86185C11.2631 7.98687 11.3333 8.15644 11.3333 8.33325C11.3333 8.51006 11.2631 8.67963 11.1381 8.80466C11.0131 8.92968 10.8435 8.99992 10.6667 8.99992ZM1.63334 4.55325C1.7407 4.62845 1.86894 4.66808 2.00001 4.66659C2.10981 4.66602 2.21778 4.63834 2.31431 4.586C2.41084 4.53366 2.49295 4.45829 2.55334 4.36659C2.8386 3.93149 3.20533 3.5557 3.63334 3.25992C3.77757 3.17313 3.88364 3.03499 3.93023 2.87324C3.97683 2.71149 3.96052 2.5381 3.88456 2.38788C3.80861 2.23766 3.67864 2.12173 3.52075 2.06337C3.36286 2.00501 3.18874 2.00854 3.03334 2.07325C2.39743 2.47184 1.85598 3.00418 1.44667 3.63325C1.35019 3.78023 1.31567 3.95937 1.35063 4.13168C1.38559 4.30398 1.4872 4.4555 1.63334 4.55325ZM14 4.66659C13.8908 4.66675 13.7832 4.64009 13.6868 4.58894C13.5903 4.53779 13.5078 4.46373 13.4467 4.37325C13.1647 3.93369 12.7975 3.55511 12.3667 3.25992C12.2224 3.17313 12.1164 3.03499 12.0698 2.87324C12.0232 2.71149 12.0395 2.5381 12.1154 2.38788C12.1914 2.23766 12.3214 2.12173 12.4793 2.06337C12.6372 2.00501 12.8113 2.00854 12.9667 2.07325C13.6026 2.47184 14.144 3.00418 14.5533 3.63325C14.6505 3.77942 14.686 3.958 14.6523 4.13023C14.6187 4.30247 14.5184 4.45447 14.3733 4.55325C14.2618 4.62499 14.1326 4.66424 14 4.66659Z",
    fill: "#1C54C5"
  })
], -1)
const _hoisted_43 = { class: "text-12px text-blue-lp-300" }
const _hoisted_44 = {
  key: 1,
  class: "flex flex-col items-start gap-1"
}
const _hoisted_45 = { class: "text-12px text-black-lp-100" }
const _hoisted_46 = { class: "text-16px text-black-lp-100 font-bold" }
const _hoisted_47 = {
  key: 0,
  class: "flex items-start gap-1 bg-yellow-lp-200 p-1 rounded-md"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.00001 3.33325C7.07703 3.33325 6.17477 3.60695 5.40735 4.11973C4.63992 4.63251 4.04178 5.36134 3.68857 6.21406C3.33536 7.06678 3.24294 8.0051 3.42301 8.91034C3.60307 9.81559 4.04753 10.6471 4.70017 11.2998C5.35282 11.9524 6.18434 12.3969 7.08959 12.5769C7.99483 12.757 8.93314 12.6646 9.78586 12.3114C10.6386 11.9581 11.3674 11.36 11.8802 10.5926C12.393 9.82515 12.6667 8.9229 12.6667 7.99992C12.6667 6.76224 12.175 5.57526 11.2998 4.70009C10.4247 3.82492 9.23768 3.33325 8.00001 3.33325ZM7.33334 1.99992V2.03707C7.16481 2.05591 6.9967 2.08194 6.82946 2.11521C5.66558 2.34672 4.59648 2.91816 3.75737 3.75728C2.91825 4.59639 2.34681 5.66549 2.1153 6.82938C1.88378 7.99326 2.0026 9.19966 2.45673 10.296C2.91086 11.3924 3.67989 12.3294 4.66659 12.9887C5.65328 13.648 6.81332 13.9999 8.00001 13.9999C9.5913 13.9999 11.1174 13.3678 12.2426 12.2426C13.3679 11.1173 14 9.59122 14 7.99992C14 6.81323 13.6481 5.65319 12.9888 4.6665C12.3295 3.6798 11.3925 2.91077 10.2961 2.45664C9.77252 2.23977 9.22384 2.09936 8.66667 2.03707V1.99992C8.66667 1.82311 8.59644 1.65354 8.47141 1.52851C8.34639 1.40349 8.17682 1.33325 8.00001 1.33325C7.8232 1.33325 7.65363 1.40349 7.5286 1.52851C7.40358 1.65354 7.33334 1.82311 7.33334 1.99992ZM10.6667 8.99992H8.00001C7.8232 8.99992 7.65363 8.92968 7.5286 8.80466C7.40358 8.67963 7.33334 8.51006 7.33334 8.33325V5.33325C7.33334 5.15644 7.40358 4.98687 7.5286 4.86185C7.65363 4.73682 7.8232 4.66659 8.00001 4.66659C8.17682 4.66659 8.34639 4.73682 8.47141 4.86185C8.59644 4.98687 8.66667 5.15644 8.66667 5.33325V7.66659H10.6667C10.8435 7.66659 11.0131 7.73682 11.1381 7.86185C11.2631 7.98687 11.3333 8.15644 11.3333 8.33325C11.3333 8.51006 11.2631 8.67963 11.1381 8.80466C11.0131 8.92968 10.8435 8.99992 10.6667 8.99992ZM1.63334 4.55325C1.7407 4.62845 1.86894 4.66808 2.00001 4.66659C2.10981 4.66602 2.21778 4.63834 2.31431 4.586C2.41084 4.53366 2.49295 4.45829 2.55334 4.36659C2.8386 3.93149 3.20533 3.5557 3.63334 3.25992C3.77757 3.17313 3.88364 3.03499 3.93023 2.87324C3.97683 2.71149 3.96052 2.5381 3.88456 2.38788C3.80861 2.23766 3.67864 2.12173 3.52075 2.06337C3.36286 2.00501 3.18874 2.00854 3.03334 2.07325C2.39743 2.47184 1.85598 3.00418 1.44667 3.63325C1.35019 3.78023 1.31567 3.95937 1.35063 4.13168C1.38559 4.30398 1.4872 4.4555 1.63334 4.55325ZM14 4.66659C13.8908 4.66675 13.7832 4.64009 13.6868 4.58894C13.5903 4.53779 13.5078 4.46373 13.4467 4.37325C13.1647 3.93369 12.7975 3.55511 12.3667 3.25992C12.2224 3.17313 12.1164 3.03499 12.0698 2.87324C12.0232 2.71149 12.0395 2.5381 12.1154 2.38788C12.1914 2.23766 12.3214 2.12173 12.4793 2.06337C12.6372 2.00501 12.8113 2.00854 12.9667 2.07325C13.6026 2.47184 14.144 3.00418 14.5533 3.63325C14.6505 3.77942 14.686 3.958 14.6523 4.13023C14.6187 4.30247 14.5184 4.45447 14.3733 4.55325C14.2618 4.62499 14.1326 4.66424 14 4.66659Z",
    fill: "#F09035"
  })
], -1)
const _hoisted_49 = { class: "text-12px text-yellow-lp-100" }
const _hoisted_50 = { class: "flex items-center justify-end" }
const _hoisted_51 = {
  class: "w-1/2 flex flex-col gap-2",
  style: {"min-width":"250px"}
}
const _hoisted_52 = { class: "flex items-center justify-between" }
const _hoisted_53 = { class: "w-1/2 flex gap-3 items-center" }
const _hoisted_54 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M3.99972 13.3333C3.64609 13.3333 3.30695 13.1929 3.05691 12.9428C2.80686 12.6928 2.66638 12.3536 2.66638 12V5.33333C2.66638 4.97971 2.80686 4.64057 3.05691 4.39052C3.30695 4.14048 3.64609 4 3.99972 4H11.9997C12.3533 4 12.6925 4.14048 12.9425 4.39052C13.1926 4.64057 13.333 4.97971 13.333 5.33333V12C13.333 12.3536 13.1926 12.6928 12.9425 12.9428C12.6925 13.1929 12.3533 13.3333 11.9997 13.3333",
    stroke: "#333333",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M5.33362 12.0011V2.66781C5.33362 2.31418 5.47409 1.97505 5.72414 1.725C5.97419 1.47495 6.31333 1.33447 6.66695 1.33447H9.33362C9.68724 1.33447 10.0264 1.47495 10.2764 1.725C10.5265 1.97505 10.667 2.31418 10.667 2.66781V12.0011",
    stroke: "#333333",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M6.66638 13.3345H9.33305",
    stroke: "#333333",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M10.667 14.6667C11.4033 14.6667 12.0003 14.0697 12.0003 13.3333C12.0003 12.597 11.4033 12 10.667 12C9.93057 12 9.33362 12.597 9.33362 13.3333C9.33362 14.0697 9.93057 14.6667 10.667 14.6667Z",
    stroke: "#333333",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M5.33333 14.6667C6.06971 14.6667 6.66667 14.0697 6.66667 13.3333C6.66667 12.597 6.06971 12 5.33333 12C4.59695 12 4 12.597 4 13.3333C4 14.0697 4.59695 14.6667 5.33333 14.6667Z",
    stroke: "#333333",
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_55 = { class: "whitespace-nowrap" }
const _hoisted_56 = { class: "w-1/2 flex gap-2 items-center" }
const _hoisted_57 = { class: "text-black-lp-100 text-16px font-bold" }
const _hoisted_58 = { class: "flex items-center justify-between" }
const _hoisted_59 = { class: "w-1/2 flex gap-3 items-center" }
const _hoisted_60 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M6 8C6 8.36667 6.3 8.66667 6.66667 8.66667H9.33333C9.7 8.66667 10 8.36667 10 8C10 7.63333 9.7 7.33333 9.33333 7.33333H6.66667C6.3 7.33333 6 7.63333 6 8Z",
    fill: "#333333"
  }),
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.3335 2H4.66679C4.46012 2 4.26013 2.1 4.13346 2.26667L2.13346 4.93333C2.12912 4.93945 2.12489 4.94562 2.12076 4.95184C2.04473 5.06011 2 5.19175 2 5.33333V13.3333C2 13.7 2.3 14 2.66667 14H13.3333C13.7 14 14 13.7 14 13.3333V5.33333C14 5.29198 13.9962 5.25147 13.9889 5.21214C13.9712 5.11228 13.9305 5.01647 13.8668 4.93333L11.8668 2.26667C11.7401 2.1 11.5401 2 11.3335 2ZM12.0001 4.66667L11.0001 3.33333H8.66667V4.66667H12.0001ZM7.33333 4.66667V3.33333H5.00012L4.00012 4.66667H7.33333ZM3.33333 6H12.6667V12.6667H3.33333V6Z",
    fill: "#333333"
  })
], -1)
const _hoisted_61 = { class: "whitespace-nowrap" }
const _hoisted_62 = { class: "w-1/2 flex gap-2 items-center" }
const _hoisted_63 = { class: "text-black-lp-100 text-16px font-bold whitespace-nowrap" }
const _hoisted_64 = { class: "text-12px font-normal" }
const _hoisted_65 = { class: "flex item-center gap-4" }
const _hoisted_66 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_67 = {
  key: 1,
  class: "flex items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate(_ctx.data.updatedAt)), 1),
      (_ctx.data.clientParentName)
        ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.handleUpdateName(_ctx.data.clientParentName)), 1))
        : _createCommentVNode("", true),
      (_ctx.data.isMinimumPiece || _ctx.data.isMinimumWeight)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_Icons, {
              name: "min-circle",
              style: {"width":"15px","height":"15px"}
            }),
            (_ctx.data.isMinimumPiece && _ctx.data.isMinimumWeight)
              ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.minimumPiecesWeight")), 1))
              : (_ctx.data.isMinimumPiece)
                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.minimumPieces")), 1))
                : (_ctx.data.isMinimumWeight)
                  ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.minimumWeight")), 1))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode("div", null, [
            _createVNode("p", _hoisted_12, _toDisplayString(_ctx.data.originCode), 1),
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.data.originName), 1)
          ]),
          _createVNode("div", null, [
            (_ctx.data.cargoType === 'plane')
              ? (_openBlock(), _createBlock("svg", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18
                ]))
              : (_ctx.data.cargoType === 'truck')
                ? (_openBlock(), _createBlock("svg", _hoisted_19, [
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]))
                : (_ctx.data.cargoType === 'ship')
                  ? (_openBlock(), _createBlock("svg", _hoisted_24, [
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28
                    ]))
                  : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("p", _hoisted_30, _toDisplayString(_ctx.data.destinationCode), 1),
            _createVNode("p", _hoisted_31, _toDisplayString(_ctx.data.destinationName), 1)
          ])
        ]),
        _createVNode("div", _hoisted_32, [
          _createVNode("div", _hoisted_33, [
            (_ctx.isDg)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_34, [
                  _hoisted_35
                ], 512)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cargoV2.components.common.dangerousGoods'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_ctx.isK)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_36, [
                  _hoisted_37
                ], 512)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cargoV2.components.common.quarantine'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_ctx.isBossPack)
              ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_38, [
                  _hoisted_39
                ], 512)), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cargoV2.components.cardRtc.bosspackProduct'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_40, [
            (_ctx.isCargoPlane && _ctx.data.cutOffTimeExceededWithoutNextConfig)
              ? (_openBlock(), _createBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode("p", _hoisted_43, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.departurePlusTwoDays")), 1),
                  _withDirectives(_createVNode("img", {
                    src: _imports_0,
                    alt: _ctx.$t('cargoV2.components.common.infoAlt')
                  }, null, 8, ["alt"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('cargoV2.components.cardRtc.departurePlusTwoDaysTooltip'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                ]))
              : (_ctx.isCargoPlane)
                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                    _createVNode("p", _hoisted_45, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.departureStart")), 1),
                    _createVNode("p", _hoisted_46, _toDisplayString(_ctx.onFormatDateEstimationDeparture), 1),
                    (_ctx.formatCalculateDiffTime && _ctx.isCargoPlane && !_ctx.data.isNearCutOffTime)
                      ? (_openBlock(), _createBlock("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode("span", _hoisted_49, _toDisplayString(_ctx.formatCalculateDiffTime), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_50, [
          _createVNode("div", _hoisted_51, [
            _createVNode("div", _hoisted_52, [
              _createVNode("div", _hoisted_53, [
                _hoisted_54,
                _createVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.totalPieces")), 1)
              ]),
              _createVNode("div", _hoisted_56, [
                _createVNode("span", _hoisted_57, _toDisplayString(_ctx.data.totalPieces), 1),
                _withDirectives(_createVNode("img", {
                  src: _imports_1,
                  alt: _ctx.$t('cargoV2.components.common.infoAlt')
                }, null, 8, ["alt"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cargoV2.components.cardRtc.totalPiecesTooltip'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_58, [
              _createVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.grossWeight")), 1)
              ]),
              _createVNode("div", _hoisted_62, [
                _createVNode("span", _hoisted_63, [
                  _createTextVNode(_toDisplayString(_ctx.data.totalWeight) + " ", 1),
                  _createVNode("span", _hoisted_64, _toDisplayString(_ctx.$t("cargoV2.components.common.kgCapital")), 1)
                ]),
                _withDirectives(_createVNode("img", {
                  src: _imports_1,
                  alt: _ctx.$t('cargoV2.components.common.infoAlt')
                }, null, 8, ["alt"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('cargoV2.components.cardRtc.grossWeightTooltip'),
                    void 0,
                    { bottom: true }
                  ]
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_65, [
            _createVNode(_component_LpButton, {
              square: "",
              outline: "",
              color: "gray-lp-200",
              fontWeight: "semibold",
              icon: "ics_o_edit_dash_black",
              customClass: "w-10 h-10",
              onClick: _ctx.onEdit
            }, null, 8, ["onClick"]),
            (_ctx.isCargoPlane)
              ? (_openBlock(), _createBlock("div", _hoisted_66, [
                  (_ctx.data.cutOffTimeExceededWithoutNextConfig)
                    ? (_openBlock(), _createBlock(_component_LpButton, {
                        key: 0,
                        textColor: "red-lp-2400",
                        title: _ctx.$t('revamp.booking.selectSchedule'),
                        fontWeight: "semibold",
                        customClass: "w-36 h-10",
                        outline: "",
                        color: "red-lp-2400",
                        icon: "ics_o_arrow_right_red",
                        onClick: _ctx.onBookingGenesis
                      }, null, 8, ["title", "onClick"]))
                    : (_openBlock(), _createBlock(_component_LpButton, {
                        key: 1,
                        icon: "arrow-right-white",
                        textColor: "white",
                        title: _ctx.$t('cargoV2.components.common.booking'),
                        fontWeight: "semibold",
                        customClass: "w-36 h-10",
                        color: "red-lp-2400",
                        onClick: _ctx.onProcess
                      }, null, 8, ["title", "onClick"]))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_67, [
                  _createVNode(_component_LpButton, {
                    onClick: _ctx.openModal,
                    icon: "arrow-right-white",
                    textColor: "white",
                    title: _ctx.$t('cargoV2.components.common.booking'),
                    fontWeight: "semibold",
                    customClass: "w-36 h-10",
                    color: "red-lp-2400"
                  }, null, 8, ["onClick", "title"])
                ]))
          ])
        ])
      ])
    ])
  ]))
}